import React from 'react';
import { ITranslationKeys } from '../../../../../../interfaces';
import { TranslationService, __ } from '../../../../utils/translation-service';
import { HeaderMainNavBar } from './HeaderMainNavBar';
import { IHeaderEnhancedProps } from '../interface';
import { HeaderNavbarBrand } from './HeaderNavbarBrand';
import { HeaderContactBlock } from '../HeaderContactBlock';
import { TrustBadges } from '../TrustBadges';
import { Favorites } from '../Favorites';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import styled from '@emotion/styled';

const keys: ITranslationKeys[] = [
    'headerPhoneFirst',
    'headerPhoneSecond',
    'nationalContactAnnotation',
    'internationalContactAnnotation',
];
TranslationService.registerKeys(keys);

const ContactBlockWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const Header = (props: IHeaderEnhancedProps) => {
    const {
        config,
        brandConfig,
        items,
        phoneNumber,
        favoriteCount,
        favoritesUrl,
        hideMenu,
        hideFavorites,
        contactTargetBlank,
    } = props;

    const localeConfig = React.useContext(LocaleConfigContext);

    const contactPagePath = `${config.contentEndpoint}${brandConfig.contactPagePath}`;

    const officeHours = items.headerContent ? items.headerContent.officeHours : null;

    const firstLine =
        officeHours?.firstLine && officeHours.firstLine.length > 0
            ? officeHours.firstLine
            : __('officeHours');
    const secondLine =
        officeHours?.secondLine && officeHours.secondLine.length > 0 ? officeHours.secondLine : '';

    return (
        <header>
            <div className="globalPageheader" style={{ background: 'white' }}>
                <div className="container">
                    <div className="row globalPageheader_brandHeight">
                        <div className="globalPageheader_brand col-sm-4">
                            <HeaderNavbarBrand />
                        </div>
                        <div className="col-sm-4 globalPageheader_trustLogos">
                            <TrustBadges portal={localeConfig.url} />
                        </div>
                        <div className="col-sm-4 globalPageheader_officeHoursWrapper text-right hidden-is hidden-xs">
                            <ContactBlockWrapper>
                                {!hideFavorites && (
                                    <Favorites count={favoriteCount} pageUrl={favoritesUrl} />
                                )}
                                <HeaderContactBlock
                                    contactPagePath={contactPagePath}
                                    phoneNumber={phoneNumber}
                                    firstLine={firstLine}
                                    secondLine={secondLine}
                                    hideSeparator={hideFavorites}
                                    contactTargetBlank={contactTargetBlank}
                                />
                            </ContactBlockWrapper>
                        </div>
                    </div>
                </div>
                {!hideMenu && <HeaderMainNavBar items={props.items} />}
            </div>
        </header>
    );
};
